import {formatTableData} from 'utils/util';

const GET_SERVICENOTICE_LIST_START = 'zb/GET_SERVICENOTICE_LIST_START';
const GET_SERVICENOTICE_LIST_SUCCESS = 'zb/GET_SERVICENOTICE_LIST_SUCCESS';
const GET_SERVICENOTICE_LIST_FAILED = 'zb/GET_SERVICENOTICE_LIST_FAILED';

let initialState = {

};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SERVICENOTICE_LIST_SUCCESS:
      return {
        ...state,
      };
    default:
      return state;
  }
}

export function getServiceNoticeList(data = {}) {
  return {
    types: [GET_SERVICENOTICE_LIST_START, GET_SERVICENOTICE_LIST_SUCCESS, GET_SERVICENOTICE_LIST_FAILED],
    promise: (client) => client.get('notify/info', {
      params: data,
    })
  };
}
